import { colors } from "@bujus/common";

const gradients = {
    main: `linear-gradient(135deg, ${colors.amaranthShades[500]}, ${colors.mulberryShades[500]})`,
};

export { gradients };
